module.exports = {
    pdf: ["application/pdf", { extension: 'pdf'}],
    msg: [{ extension: 'msg'}],
    excel: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
};
